import { GetDailyTrafficFlowData, GetAllTrafficFlowData} from '../../../api/eastCoastMonitorApi/trafficFlowApi'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'

const state = {
  trafficFlow: [],
  totalTrafficFlow: {}
}

const getters = {
  getTrafficFlow: state => {
    return state.trafficFlow
  },
}

const actions = {
  async GetDailyTrafficFlowData({ commit }, condition = {}) {
    const result = await GetDailyTrafficFlowData(condition)
    if(result.success) {
      commit('trafficFlow', result.data)
    }
  }, 

  async GetAllTrafficFlowData({ commit }) {
    const result = await GetAllTrafficFlowData()
    if(result.success) {
      commit('totalTrafficFlow', result.data)
    }
  }
}

const mutations = {
  trafficFlow: (state, data) => {
    if(Utils.isEmptyObject(data)) {
      state.trafficFlow = []
      return
    }

    state.trafficFlow = data
  },

  totalTrafficFlow: (state, data) => {
    if(Utils.isEmptyObject(data)) {
      state.totalTrafficFlow = {}
      return
    }

    state.totalTrafficFlow = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}